import { all, put, takeEvery } from "redux-saga/effects";
import searchResultService from "../../../src/services/searchResultService";
import {
  GET_SEARCH_RESULT,
  GET_LOADED_DATA,
  GET_RANDOM_CHART,
} from "./types";
import resultsService from "../../../src/services/resultsService";

import * as searchAction from "./action";

//20240514 submit Enth Search request
function* searchResultSaga(req) {
  try {

    //202403029 jag transitioning to auth0
    if (!localStorage.getItem("key")) {
      //localStorage.setItem("key",key);
      console.log('Hard coding Key in localStorage.');
      localStorage.setItem("key", "Z54tu0WCESgRHOfAtCMZc281iN01zYaRAakeZNLXHIqrUa5exJqWYbZqVxpO0iDMqEq7Pmxpjc694U/ScIXqewDQ29rnFqe9BUwEgFO4vFm5zpM2ofABkceXGs5MvTGzEsh3FA5ztq0qRSiiND2O5ruxEQMM2mDuY7EoQ1BfiIF90kCiuADjB4aHvEvBhAz4u4EpKczyjBQ6lfFVA2pW/YsU1EM7DA8xgFcJ2X6DSXyqHNF1Ayj0Ix8eFZzT3aSpGSoVWTI0VmHFxFMivORxIU3SwCwBZu1MnxSUtl+E3pbU2UGkzTRSZJx58ptfVGkej9jcdhT5IRopjnZMzRg2wRa4x4/ea4mW/uSh5mtoh5c=");
    }

    console.log('Key: ', req.values.key);
    console.log('DefaultKey: ', localStorage.getItem("key"));
    console.log('Request: ', req.values.q);

    const data = { key: req.values.key || localStorage.getItem("key"), q: req.values.q };  //added 20240328 added test for APIKey
    let res = yield searchResultService.searchResultQuery(data); //20240327 jag submits request to Enth
    if (res == null) {
        console.log('Error', "Enth Search response is null.");
    }
    else if(typeof res === 'string') {
      res = JSON.parse(res);
    }

    const searchData = res?.results?.append?.map((item) => {
      return {
        id: item?.output.id,  //added 20240316 jag
        json: item?.output?.locationip,
        sources: item?.output?.sources,
        score: item?.output?.score,
        name: item?.output?.name,
      };
    });

    if(searchData?.length) {
     yield put(searchAction.setSearchedData(searchData));
    }
    else {
      //alert("No Results found.")  //20240329 jag
      yield put(searchAction.setSearchedData([]));
      searchAction.getRandomChart({});
      //setLoader(false);

    }
    if(res?.results?.universals?.locationip) {
      yield put(
        searchAction.getRandomChart(res?.results?.universals?.locationip)
      );
    }
    
  } catch (error) {
     console.log('Exception Encounterd', error);
  }
}

//20240514 test individual result, set if present
function* loadSearchResults(req) {
  const { id, name, json } = req.values;
  const key = localStorage.getItem("key"); //added 20240316 jag test


  //let url =
  //  window.location.origin + json?.replace("http://local.enth.com:8080/", "/");
  try {
    //test 202403016 jag
    const data = { key: key, id: req.values.id };
   // const key2 = localStorage.getItem("key"); //added 20240316 jag test

    //let res = yield resultsService.getResults(data);
    console.log("saga::loadSearchResults() ID: ", id);
    let res = yield searchResultService.getResults(data);
    if(typeof res === 'string') {
      res = JSON.parse(res);
    }
    yield put(searchAction.setLoadedData({ name, values: res }));
    

    //const response = yield searchResultService.searchLocationIp(url);
   // yield put(searchAction.setLoadedData({ name, values: response }));

  } catch (error) {
    console.log("saga::loadSearchResults() Exception Encountered ID: ", id);
  }
}

function* randomLineChartData(req) {
  try {
    let url =
      window.location.origin +
      req?.values?.replace("http://local.enth.com:8081/", "/");
    const response = yield searchResultService.searchLocationIp(url);
    yield put(searchAction.setRandomChart(response));
  } catch (error) {
    console.log(error, "error");
  }
}

export default function* combinedSaga() {
  yield all([
    takeEvery(GET_SEARCH_RESULT, searchResultSaga),
    takeEvery(GET_LOADED_DATA, loadSearchResults),
    takeEvery(GET_RANDOM_CHART, randomLineChartData),
  ]);
}
